import { render, staticRenderFns } from "./CategorySideBar.vue?vue&type=template&id=0f136049&scoped=true&"
import script from "./CategorySideBar.vue?vue&type=script&lang=js&"
export * from "./CategorySideBar.vue?vue&type=script&lang=js&"
import style0 from "./CategorySideBar.vue?vue&type=style&index=0&id=0f136049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f136049",
  null
  
)

export default component.exports